import {openDB, deleteDB} from "idb";

const dbPromise = async () => {

    if (!('indexedDB' in window)) {
        throw new Error('Browser does not support IndexedDB')
    }

    const dbName = 'MMR_DB'
    const version = 2 //versions start at 1 update when adding store

    return await openDB(dbName, version, {
        upgrade(db) {
            if (!db.objectStoreNames.contains('buildings')) {
                db.createObjectStore('buildings', {keyPath: "buildingId"});
            }

            if (!db.objectStoreNames.contains('reads')) {
                db.createObjectStore('reads', {keyPath: "meterId"});
            }

            if (!db.objectStoreNames.contains('user-settings')) {
                db.createObjectStore('user-settings');
            }
        },
    });
}

export const saveItemDB = async (storeName, val, key) => {
    try {
        const db = await dbPromise()
        const tx = db.transaction(storeName, 'readwrite')
        const store = tx.objectStore(storeName)

        store.put(val, key)

        return tx.done
    } catch (error) {
        console.error('[indexedDBService] saveItemDB Error', error);
        return error
    }
}

export const deleteItemDB = async (storeName, key) => {
    try {
        const db = await dbPromise()
        const tx = db.transaction(storeName, 'readwrite')
        const store = tx.objectStore(storeName)

        store.delete(key)

        return tx.done
    } catch (error) {
        console.error('[indexedDBService] deleteItemDB Error', error);
        return error
    }
}

async function clearItemDB(storeName) {
    const db = await dbPromise()
    const tx = db.transaction(storeName, 'readwrite')
    const store = tx.objectStore(storeName)

    store.clear()
    tx.commit();
    return tx.done
}

export async function deleteMmrDb()
{
    const dbName = 'MMR_DB'
    openDB(dbName).then((db) => {
        db.close(); 
        return deleteDB(dbName); 
    }).then(() => {
        console.log(`Database "${dbName}" deleted.`);
    }).catch((error) => {
        console.error(`Error deleting database: ${error}`);
    });
}
export async function deleteBuildingsAndReadsDB() {
    try {
        await clearItemDB('buildings')
        await clearItemDB('reads')
        await clearItemDB('user-settings')
    } catch (error) {
        console.error('[indexedDBService] deleteBuildingsAndReads Error', error);
        return error
    }
}

export async function getItemDB(storeName, key) {
    try {
        return (await dbPromise()).get(storeName, key);
    } catch (error) {
        console.error('[indexedDBService] getItemDB Error', error);
        return error
    }
}

export async function getAllItemsDB(storeName) {
    try {
        return (await dbPromise()).getAll(storeName);
    } catch (error) {
        console.error('[indexedDBService] getAllItemsDB Error', error);
        return error
    }
}

export async function getAllKeysDB(storeName) {
    try {
        return (await dbPromise()).getAllKeys(storeName);
    } catch (error) {
        return error
    }
}


export default {
    getItemDB,
    saveItemDB,
    deleteItemDB,
    getAllKeysDB,
    getAllItemsDB,
    deleteMmrDb
}